module.exports = __webpack_public_path__ + "img/small-3.63af8bfa.jpg";